import { render, staticRenderFns } from "./prontuario.vue?vue&type=template&id=45f15cba&scoped=true"
import script from "./prontuario.vue?vue&type=script&lang=js"
export * from "./prontuario.vue?vue&type=script&lang=js"
import style0 from "./prontuario.vue?vue&type=style&index=0&id=45f15cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f15cba",
  null
  
)

export default component.exports